import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Card, CardBody, CardHeader,
  Container, Row, Col, Button, FormGroup, Label, Input,
} from "reactstrap";
import { businessesRepo } from "data/repositories/businessesRepo";
import { provincesRepo } from "data/repositories/provincesRepo";

import { CATEGORY_LABELS } from "labels/tr";

const CATEGORIES = Object.entries(CATEGORY_LABELS).map(([value, label]) => ({ value, label }));

export default function PartnerEditBusiness() {
  const { id } = useParams();
  const navigate = useNavigate();
  const isNew = !id || id === "new";

  const [provinces, setProvinces] = useState([]);
  const [form, setForm] = useState({
    name: "", description: "", category: "hotel", provinceId: "",
    addressLine: "", phone: "", priceFromText: "", ownerUserId: "",
  });

  useEffect(() => {
    setProvinces(provincesRepo.list());
    if (!isNew) {
      const biz = businessesRepo.getById(id);
      if (biz) {
        setForm({
          name: biz.name || "",
          description: biz.description || "",
          category: biz.category || "hotel",
          provinceId: biz.location?.provinceId || "",
          addressLine: biz.location?.addressLine || "",
          phone: biz.contact?.phone || "",
          priceFromText: biz.priceFromText || "",
          ownerUserId: biz.ownerUserId || "",
        });
      }
    }
  }, [id, isNew]);

  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      name: form.name,
      description: form.description,
      category: form.category,
      location: {
        provinceId: form.provinceId,
        addressLine: form.addressLine,
      },
      contact: {
        phone: form.phone,
      },
      priceFromText: form.priceFromText,
      ownerUserId: form.ownerUserId || "u-business-trabzon",
    };

    if (isNew) {
      businessesRepo.create(payload);
    } else {
      businessesRepo.update(id, payload);
    }
    navigate("/admin/partner/businesses");
  };

  return (
    <>
      <div className="header bg-gradient-warning pb-6 pt-5 pt-md-7">
        <Container fluid>
          <h2 className="text-white mb-0">{isNew ? "Yeni İşletme" : "İşletme Düzenle"}</h2>
        </Container>
      </div>

      <Container className="mt--6" fluid>
        <Row className="justify-content-center">
          <Col lg={8}>
            <Card className="shadow">
              <CardHeader><h3 className="mb-0">İşletme Bilgileri</h3></CardHeader>
              <CardBody>
                <form onSubmit={handleSubmit}>
                  <FormGroup>
                    <Label>İşletme Adı</Label>
                    <Input value={form.name} onChange={set("name")} required />
                  </FormGroup>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label>Kategori</Label>
                        <Input type="select" value={form.category} onChange={set("category")}>
                          {CATEGORIES.map((c) => (
                            <option key={c.value} value={c.value}>{c.label}</option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label>Şehir</Label>
                        <Input type="select" value={form.provinceId} onChange={set("provinceId")} required>
                          <option value="">Seçin</option>
                          {provinces.map((p) => (
                            <option key={p.id} value={p.id}>{p.name}</option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>
                  <FormGroup>
                    <Label>Açıklama</Label>
                    <Input type="textarea" value={form.description} onChange={set("description")} rows={3} />
                  </FormGroup>
                  <Row>
                    <Col md={4}>
                      <FormGroup>
                        <Label>Adres</Label>
                        <Input value={form.addressLine || ""} onChange={set("addressLine")} />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label>Telefon</Label>
                        <Input value={form.phone || ""} onChange={set("phone")} />
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label>Fiyat Aralığı</Label>
                        <Input value={form.priceFromText || ""} onChange={set("priceFromText")} placeholder="₺1.250 / gece" />
                      </FormGroup>
                    </Col>
                  </Row>
                  <FormGroup>
                    <Label>Owner User ID</Label>
                    <Input value={form.ownerUserId || ""} onChange={set("ownerUserId")} placeholder="u-business-trabzon" />
                  </FormGroup>
                  <Button color="primary" type="submit">{isNew ? "Oluştur" : "Güncelle"}</Button>
                  <Button color="secondary" className="ml-2" onClick={() => navigate(-1)}>Vazgeç</Button>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
